import { cn } from "@/utils/cn";

interface PaginationComponentProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export const PaginationComponent = ({ currentPage, totalPages, onPageChange }: PaginationComponentProps) => {
    const getVisiblePages = () => {
        const pages = [];
        const maxVisiblePages = 5;

        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
            const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
        }

        return pages;
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const visiblePages = getVisiblePages();

    return (
        <div className="flex flex-row items-center justify-center gap-x-2 mt-6">
            {/* Previous Button */}
            <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className={cn(
                    "px-3 py-2 font-clash-display text-sm font-medium transition-colors",
                    currentPage === 1
                        ? "text-medium-grey cursor-not-allowed"
                        : "text-medium-dark-grey hover:text-black-dark-grey cursor-pointer"
                )}
            >
                Previous
            </button>

            {/* Page Numbers */}
            {visiblePages.map((page) => (
                <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={cn(
                        "w-8 h-8 flex items-center justify-center rounded font-clash-display text-sm font-medium transition-colors",
                        page === currentPage
                            ? "bg-primary-button text-white"
                            : "text-medium-dark-grey hover:text-black-dark-grey hover:bg-stroke cursor-pointer"
                    )}
                >
                    {page}
                </button>
            ))}

            {/* Next Button */}
            <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className={cn(
                    "px-3 py-2 font-clash-display text-sm font-medium transition-colors",
                    currentPage === totalPages
                        ? "text-medium-grey cursor-not-allowed"
                        : "text-medium-dark-grey hover:text-black-dark-grey cursor-pointer"
                )}
            >
                Next
            </button>
        </div>
    );
};

